import { api } from "../api";

export type CheckListItem = {
  id: number;
  checklistId: number;
  content: string;
  isChecked: boolean;
  order: number;
  createdAt: Date;
};

export type CreateCheckListItemBody = Omit<CheckListItem, "id, createdAt">;

export const createChecklistItem = async (body: CreateCheckListItemBody) => {
  let url = `/checklistItem`;
  return await api.post(url, body);
};

export type UpdateCheckListItemBody = Omit<CheckListItem, "createdAt, checklistId">;

export const updateChecklistItem = async (body: UpdateCheckListItemBody) => {
  let url = `/checklistItem`;
  return await api.put(url, body);
};

export const deleteChecklistItem = async (checklistItemId: number) => {
  let url = `/checklistItem/${checklistItemId}`;
  return await api.delete(url);
};
